import Preferences from "./preferences";
import VolunteerPreferences from "./volunteers/volunteer-preferences";

function isVolunteerPreferences(
  toBeDetermined: VolunteerPreferences | Preferences
): toBeDetermined is VolunteerPreferences {
  if (!toBeDetermined) return false;
  return !!(
    (toBeDetermined as VolunteerPreferences).schedule &&
    (toBeDetermined as VolunteerPreferences).skillsAndInterests
  );
}

export default isVolunteerPreferences;



// WEBPACK FOOTER //
// ./src/models/resource-management/resource-schedule-guard.ts